import { render, staticRenderFns } from "./StaticSection.vue?vue&type=template&id=da636602"
import script from "./StaticSection.vue?vue&type=script&lang=js"
export * from "./StaticSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StaticSectionContact: require('/home/forge/farescraper.com/components/StaticSectionContact.vue').default})
